<template>
  <div class="mobile-menu" :class="{ open: open }" @click="handleMobileMenu">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
</template>

<script>
import { bus } from '../main';

export default {
  name: 'MobileMenu',
  props: {
    openSide: Boolean,
  },
  data() {
    return {
      open: false,
      // open: this.openSide
    };
  },

  created() {
    // bus.$on('closeSide', (e) => {
    //   this.open = e;
    //   console.log(e);
    // });
  },

  mounted() {},

  methods: {
    handleMobileMenu() {
      this.open = true;
			bus.$emit('openSide', this.open);
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-menu {
  transition: all 0.3s;
  cursor: pointer;
  /* &.open {
    .bar {
			background-color: white;
      &:nth-of-type(1) {
        transform: translateY(7px) rotate(45deg);
      }
      &:nth-of-type(2) {
        opacity: 0;
      }
      &:nth-of-type(3) {
        transform: translateY(-7px) rotate(-45deg);
      }
    }
  } */
  .bar {
    height: 2px;
    width: 20px;
    display: block;
    margin: 5px auto;
    position: relative;
    border-radius: 50vh;
    transition: all 0.3s;
    background-color: black;
  }
}
</style>
